
import React from "react";
import { ImageIcon } from "lucide-react";

interface ImageUploadPreviewProps {
  previewUrl: string | null;
}

const ImageUploadPreview: React.FC<ImageUploadPreviewProps> = ({ previewUrl }) => {
  if (previewUrl) {
    return (
      <div className="mt-4 border-2 border-border rounded-lg p-3 bg-muted/10 shadow-sm">
        <img 
          src={previewUrl} 
          alt="Preview" 
          className="max-w-full h-auto rounded-md mx-auto"
          style={{ maxHeight: '200px' }}
        />
      </div>
    );
  }
  
  return (
    <div className="flex flex-col items-center justify-center h-40 border-2 border-dashed border-border rounded-lg bg-muted/10">
      <ImageIcon className="w-16 h-16 text-muted-foreground mb-2" />
      <p className="text-muted-foreground">Image preview will appear here</p>
    </div>
  );
};

export default ImageUploadPreview;
